import { render, staticRenderFns } from "./KeyResultHome.vue?vue&type=template&id=3bda470e&scoped=true&"
import script from "./KeyResultHome.vue?vue&type=script&lang=js&"
export * from "./KeyResultHome.vue?vue&type=script&lang=js&"
import style0 from "./KeyResultHome.vue?vue&type=style&index=0&id=3bda470e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bda470e",
  null
  
)

export default component.exports